import app from 'firebase/app'
import 'firebase/auth';
import 'firebase/database';

const config = {
  apiKey: "AIzaSyBZUO_PdIk46_sADjP4O390IoXDhAdjVwg",
  authDomain: "budgets-1ec3a.firebaseapp.com",
  databaseURL: "https://budgets-1ec3a.firebaseio.com",
  projectId: "budgets-1ec3a",
  storageBucket: "",
  messagingSenderId: "37779459025",
  appId: "1:37779459025:web:bde0d63a1d7616b9"
};

class Firebase {
  constructor() {
    app.initializeApp(config);
    this.auth = app.auth();
    this.db = app.database();
  }


  // User API

  user = uid => this.db.ref(`users/${uid}`);

  users = () => this.db.ref('users');

  // Auth API

  //Email Sign Up
  doCreateUserWithEmailAndPassword = (email, password) => {
    return this.auth.createUserWithEmailAndPassword(email, password);
  }
  //Email Sign In
  doSignInWithEmailAndPassword = (email, password) => {
    return this.auth.signInWithEmailAndPassword(email, password);
  }
  // Guest Sign In
  doSignInAsGuest = () => this.auth.signInAnonymously();
  //Sign Out
  doSignOut = () => this.auth.signOut();
  //Reset Password
  doPasswordReset = email => this.auth.sendPasswordResetEmail(email);
  // Password Update
  doPasswordUpdate = password => this.auth.currentUser.updatePassword(password);
  // Email Update
  doEmailUpdate = email => this.auth.currentUser.updateEmail(email);
}

export default Firebase;